import React from 'react'

import ErrorBoundary from "../../../error-boundary"
import VScroll from '../../../gd-components/scrolling/custom-v-scroll/v-scroll'
import PreferencesHeader from "./header/header"

type Props = {
    noHeader?   : boolean

    className?  : string
    children?   : any
}

export default class PreferencesPanel extends React.Component<Props> {
    constructor(props:Props) {
        super(props)
    }

    onClose = () => {
        gd.layout.right.hide()
    }

    render() {
        const classes = Classes('app-right-container right-panel preferences-panel', this.props.className)

        return (
            <div className={classes}>
                {!this.props.noHeader &&
                    <PreferencesHeader onClose={this.onClose} title="Preferences"/>}

                <ErrorBoundary>
                    <VScroll className="children-container" containerClass="v-right-children-container" minDragHeight={10}>
                        {this.props.children}
                    </VScroll>
                </ErrorBoundary>
            </div>
        )
    }
}